import jwt_decode from 'jwt-decode';
import { useReducer } from 'react';

export const authTokenStorageKey = '__at__';

type AuthStatusAction =
  | {
      type: 'changeAuthToken';
      payload: {
        token: string;
      };
    }
  | { type: 'cleanAuthToken' };

interface AuthStatusState {
  id?: string;
  authorized: boolean;
  username?: string;
  platformUser?: boolean;
}

function getStatusFromToken(token: string | null): AuthStatusState {
  if (token) {
    const claims = jwt_decode<any>(token);
    const { exp, id, name, pu } = claims;
    if (exp * 1000 - new Date().getTime() > 0) {
      return {
        id,
        username: name,
        authorized: true,
        platformUser: !!pu,
      };
    }
  }
  return {
    authorized: false,
  };
}

function authStatusReducer(
  state: AuthStatusState,
  action: AuthStatusAction,
): AuthStatusState {
  switch (action.type) {
    case 'cleanAuthToken':
      localStorage.removeItem(authTokenStorageKey);
      return {
        authorized: false,
      };
    case 'changeAuthToken':
      localStorage.setItem(authTokenStorageKey, action.payload.token);
      return getStatusFromToken(action.payload.token);
  }
}

const initialState = getStatusFromToken(
  localStorage.getItem(authTokenStorageKey),
);

export function useAuthStatusReducer() {
  const [state, dispatch] = useReducer(authStatusReducer, initialState);
  return {
    status: state,
    cleanAuthToken: () => dispatch({ type: 'cleanAuthToken' }),
    changeAuthToken: (token: string) =>
      dispatch({ type: 'changeAuthToken', payload: { token } }),
  };
}
